var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.currentTab
    ? _c(
        "div",
        { staticClass: "t-nav", class: { "t-nav--collapsed": _vm.$isMobile } },
        [
          _c(
            "div",
            {
              staticClass: "t-nav__header",
              class: { "t-mar--r-lg": !_vm.partnerMode && !_vm.$isMobile },
            },
            [
              _vm.partnerMode
                ? _c(
                    "router-link",
                    { staticClass: "t-dis--in-blk", attrs: { to: "/" } },
                    [
                      !_vm.$isMobile
                        ? _c("img", {
                            attrs: {
                              src: require(`@/lib/assets/images/partner/${_vm.partnerId}/logo.svg`),
                              height: "30px",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require(`@/lib/assets/images/partner/${_vm.partnerId}/icon.svg`),
                              height: "30px",
                            },
                          }),
                    ]
                  )
                : _c(
                    "router-link",
                    { staticClass: "t-dis--in-blk", attrs: { to: "/" } },
                    [
                      !_vm.$isMobile
                        ? _c("img", {
                            attrs: {
                              src: require("@/lib/assets/images/trainn-by-cb-logo.svg"),
                              height: "36px",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/lib/assets/images/Trainn-Logo-Assets/SVG/Trainn-logo-blue.svg"),
                              height: "30px",
                            },
                          }),
                    ]
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "t-nav__main" }, [
            _c(
              "div",
              { staticClass: "t-nav__tabs t-pad--t-mi" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active":
                        _vm.currentTab == _vm.tabs.dashboard,
                    },
                    attrs: { to: "/dashboard" },
                  },
                  [
                    _c("DashboardIcon"),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("nav.tab.dashboard"))),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "'t-nav__tab-wrap" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "t-nav__tab t-nav__tab--collapsible",
                        attrs: { to: "/library" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleLibrary()
                          },
                        },
                      },
                      [
                        _c("LibraryIcon"),
                        _vm._v(" "),
                        !_vm.expandLibrary && !_vm.$isMobile
                          ? _c("ChevronRightIcon")
                          : !_vm.$isMobile
                          ? _c("ChevronTopIcon")
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.library"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("t-slide", [
                      _vm.expandLibrary
                        ? _c(
                            "div",
                            { staticClass: "t-nav__subtabs" },
                            _vm._l(
                              _vm.$user.workspace.spaces,
                              function (space) {
                                return _c(
                                  "router-link",
                                  {
                                    key: space.id,
                                    staticClass: "t-nav__subtab",
                                    class: [
                                      {
                                        "t-nav__tab--active":
                                          _vm.rootFolderId == space.id,
                                      },
                                    ],
                                    attrs: { to: `/library/${space.id}` },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(space.title) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm.appEmbedsEnabled
                  ? _c(
                      "div",
                      { staticClass: "'t-nav__tab-wrap" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "t-nav__tab t-nav__tab--collapsible t-pos--rel",
                            class: [
                              {
                                "t-nav__tab--active":
                                  _vm.currentTab == _vm.tabs.embed &&
                                  !_vm.showEmbedSubTab,
                              },
                              {
                                "t-disabled-opacity t-cursor--not-allow":
                                  _vm.$isMobile,
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.toggleEmbed()
                              },
                            },
                          },
                          [
                            _c("InAppTutorialsIcon"),
                            _vm._v(" "),
                            !_vm.showEmbedSubTab && !_vm.$isMobile
                              ? _c("ChevronRightIcon")
                              : !_vm.$isMobile
                              ? _c("ChevronTopIcon")
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$isMobile
                              ? _c("span", [_vm._v("In-App Tutorials")])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("t-slide", [
                          _vm.showEmbedSubTab
                            ? _c(
                                "div",
                                { staticClass: "t-nav__subtabs" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "t-nav__subtab",
                                      class: [
                                        {
                                          "t-nav__subtab--active":
                                            _vm.subTab == "embeds_home",
                                        },
                                      ],
                                      attrs: { to: { name: "embeds_home" } },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Builder\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "t-nav__subtab",
                                      class: [
                                        {
                                          "t-nav__subtab--active":
                                            _vm.subTab ==
                                            "embeds_configuration",
                                        },
                                      ],
                                      attrs: {
                                        to: { name: "embeds_configuration" },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Configuration\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active":
                        _vm.currentTab == _vm.tabs.collections,
                    },
                    attrs: { to: "/collections" },
                  },
                  [
                    _c("CollectionIcon"),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("nav.tab.learning_path"))),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "'t-nav__tab-wrap" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "t-nav__tab t-nav__tab--collapsible",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.hub &&
                              !_vm.showVideoHubSubTab,
                          },
                          {
                            "t-disabled-opacity t-cursor--not-allow":
                              _vm.$isMobile,
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toggleVideoHub()
                          },
                        },
                      },
                      [
                        _c("HubIcon"),
                        _vm._v(" "),
                        !_vm.showVideoHubSubTab && !_vm.$isMobile
                          ? _c("ChevronRightIcon")
                          : !_vm.$isMobile
                          ? _c("ChevronTopIcon")
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("nav.tab.hub")))])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("t-slide", [
                      _vm.showVideoHubSubTab
                        ? _c(
                            "div",
                            { staticClass: "t-nav__subtabs" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "hub_analytics",
                                    },
                                  ],
                                  attrs: { to: "/hub/analytics" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("hub.analytics.title")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !_vm.canUpdateVideoHub && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "\n                !canUpdateVideoHub && {\n                  content: $t('message.no_access'),\n                  offset: 8\n                }\n              ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "hub_builder",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !(
                                          _vm.$user.can("update", "course") ||
                                          _vm.$user.can("update", "academy")
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to: (_vm.canUpdateVideoHub && "/hub") || "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("hub.builder.title")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "'t-nav__tab-wrap" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "t-nav__tab t-nav__tab--collapsible",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.academy &&
                              !_vm.showAcademySubTab,
                          },
                          {
                            "t-disabled-opacity t-cursor--not-allow":
                              _vm.$isMobile,
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toggleAcademy()
                          },
                        },
                      },
                      [
                        _c("AcademyIcon"),
                        _vm._v(" "),
                        !_vm.showAcademySubTab && !_vm.$isMobile
                          ? _c("ChevronRightIcon")
                          : !_vm.$isMobile
                          ? _c("ChevronTopIcon")
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.academy"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("t-slide", [
                      _vm.showAcademySubTab
                        ? _c(
                            "div",
                            { staticClass: "t-nav__subtabs" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_home",
                                    },
                                  ],
                                  attrs: { to: "/academy" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_home")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !(
                                        _vm.$user.can("update", "course") ||
                                        _vm.$user.can("update", "academy")
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "\n                !(\n                  $user.can('update', 'course') ||\n                  $user.can('update', 'academy')\n                ) && {\n                  content: $t('message.no_access'),\n                  offset: 8\n                }\n              ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "course_builder",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !(
                                          _vm.$user.can("update", "course") ||
                                          _vm.$user.can("update", "academy")
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      ((_vm.$user.can("update", "course") ||
                                        _vm.$user.can("update", "academy")) &&
                                        "/academy/courses") ||
                                      "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.course_builder")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !(
                                        _vm.$user.can("update", "course") ||
                                        _vm.$user.can("update", "academy")
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "\n                !(\n                  $user.can('update', 'course') ||\n                  $user.can('update', 'academy')\n                ) && {\n                  content: $t('message.no_access'),\n                  offset: 8\n                }\n              ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_builder",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !(
                                          _vm.$user.can("update", "course") ||
                                          _vm.$user.can("update", "academy")
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      _vm.$user.can("update", "academy") &&
                                      _vm.academyBuilderUrl,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_builder")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !_vm.$user.can(
                                        "update",
                                        "academy"
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "\n                !$user.can('update', 'academy') && {\n                  content: $t('message.no_access'),\n                  offset: 8\n                }\n              ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_config",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !_vm.$user.can("update", "academy"),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      (_vm.$user.can("update", "academy") &&
                                        "/academy/configurations") ||
                                      "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_config")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: !_vm.$user.can(
                                        "update",
                                        "training_event"
                                      ) && {
                                        content: _vm.$t("message.no_access"),
                                        offset: 8,
                                      },
                                      expression:
                                        "\n                !$user.can('update', 'training_event') && {\n                  content: $t('message.no_access'),\n                  offset: 8\n                }\n              ",
                                    },
                                  ],
                                  staticClass: "t-nav__subtab",
                                  class: [
                                    {
                                      "t-nav__subtab--active":
                                        _vm.subTab == "academy_events",
                                    },
                                    {
                                      "t-disabled-opacity t-cursor--not-allow":
                                        _vm.$isMobile ||
                                        !_vm.$user.can(
                                          "update",
                                          "training_event"
                                        ),
                                    },
                                  ],
                                  attrs: {
                                    to:
                                      (_vm.$user.can(
                                        "update",
                                        "training_event"
                                      ) &&
                                        "/academy/events") ||
                                      "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("nav.subtab.academy_events")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active": _vm.currentTab == _vm.tabs.learners,
                    },
                    attrs: { to: "/learners" },
                  },
                  [
                    _c("UserIcon", { attrs: { fill: "#8A8D93" } }),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("nav.tab.learners")))])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "t-nav__tab",
                    class: {
                      "t-nav__tab--active":
                        _vm.currentTab == _vm.tabs.learnerGroup,
                    },
                    attrs: { to: "/learner_groups" },
                  },
                  [
                    _c("UserGroupIcon", {
                      attrs: { size: "16", fill: "#8A8D93" },
                    }),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("nav.tab.learner_group"))),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$user.can("update", "email_setting")
                  ? _c(
                      "router-link",
                      {
                        staticClass: "t-nav__tab",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.emails,
                          },
                        ],
                        attrs: { to: "/emails/settings" },
                      },
                      [
                        _c("EmailIcon"),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.email"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.partnerMode
                  ? _c(
                      "router-link",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: !_vm.$user.can("update", "workspace") && {
                              content: _vm.$t("message.no_access"),
                              offset: 8,
                            },
                            expression:
                              "\n          !$user.can('update', 'workspace') && {\n            content: $t('message.no_access'),\n            offset: 8\n          }\n        ",
                          },
                        ],
                        staticClass: "t-nav__tab",
                        class: [
                          {
                            "t-nav__tab--active":
                              _vm.currentTab == _vm.tabs.integrations,
                          },
                          {
                            "t-disabled-opacity t-cursor--not-allow":
                              !_vm.$user.can("update", "workspace"),
                          },
                        ],
                        attrs: {
                          to: _vm.$user.can("update", "workspace")
                            ? "/integrations"
                            : "",
                        },
                      },
                      [
                        _c("IntegrationIcon"),
                        _vm._v(" "),
                        !_vm.$isMobile
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("nav.tab.integrations"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "t-nav__aside" }, [
            _c(
              "div",
              { staticClass: "t-nav__actions" },
              [
                _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.workspace.displayName,
                        expression: "workspace.displayName",
                      },
                    ],
                    staticClass: "t-nav__action",
                    attrs: { to: "/settings" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "t-mar--r-ti",
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 15 17",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M11.9546 8.23682C11.9546 7.83452 12.0517 7.43798 12.2373 7.08105C12.4229 6.72415 12.6917 6.41709 13.021 6.18604C13.2206 6.04079 13.3599 5.82692 13.4121 5.58545C13.4648 5.3416 13.4248 5.08665 13.3 4.87061C13.1753 4.65463 12.9743 4.49278 12.7368 4.4165C12.4992 4.34028 12.2412 4.35508 12.0139 4.45825C11.651 4.62597 11.2532 4.7042 10.8537 4.68677C10.4518 4.66919 10.0597 4.5553 9.71117 4.35425C9.36269 4.15318 9.06772 3.8709 8.85131 3.53174C8.63493 3.19254 8.503 2.80604 8.46752 2.40527V2.40454C8.44271 2.15763 8.32747 1.92852 8.14379 1.76147C7.95881 1.59326 7.71778 1.50003 7.46776 1.5C7.21776 1.5 6.97673 1.59331 6.79174 1.76147C6.60679 1.92968 6.49099 2.1608 6.46728 2.40967C6.4649 2.43468 6.46101 2.45949 6.45629 2.48364C6.41142 2.85625 6.28496 3.21477 6.08275 3.53174C5.86634 3.87094 5.5714 4.15316 5.22289 4.35425C4.87435 4.55535 4.48232 4.66918 4.08031 4.68677C3.67827 4.70434 3.27762 4.62525 2.91283 4.45532V4.45459C2.68761 4.35501 2.43335 4.34182 2.19872 4.41724C1.9614 4.49354 1.76094 4.6555 1.63622 4.87134C1.51151 5.0873 1.47161 5.3424 1.52416 5.58618C1.57676 5.82981 1.7179 6.04509 1.9204 6.19043H1.91967C2.24624 6.42101 2.51305 6.7263 2.6975 7.08105C2.88306 7.43796 2.98021 7.83455 2.98021 8.23682C2.98017 8.63893 2.88296 9.03506 2.6975 9.39185C2.51298 9.74674 2.24568 10.0519 1.91894 10.2825L1.91967 10.2832C1.71698 10.4285 1.57541 10.6437 1.5227 10.8875C1.47002 11.1314 1.50991 11.3869 1.63476 11.603C1.75961 11.819 1.96044 11.9809 2.19799 12.0571C2.4355 12.1333 2.693 12.1184 2.92016 12.0154C3.28323 11.8473 3.68127 11.7688 4.08104 11.7861C4.48313 11.8036 4.87498 11.9176 5.22362 12.1187C5.5723 12.3198 5.86773 12.6018 6.08422 12.9412C6.2998 13.2791 6.4305 13.664 6.46654 14.0632H6.46728C6.49095 14.3122 6.60674 14.5432 6.79174 14.7114C6.97674 14.8796 7.21771 14.9729 7.46776 14.9729C7.7178 14.9729 7.95881 14.8797 8.14379 14.7114C8.32875 14.5432 8.44459 14.3122 8.46825 14.0632C8.50433 13.6642 8.63581 13.2798 8.85131 12.9419C9.06773 12.6026 9.36263 12.3205 9.71117 12.1194C10.0597 11.9183 10.4517 11.8037 10.8537 11.7861C11.2533 11.7687 11.651 11.8476 12.0139 12.0154L12.1003 12.0498C12.3052 12.1208 12.5288 12.1238 12.7368 12.0571C12.9743 11.9809 13.1752 11.819 13.3 11.603C13.4249 11.3869 13.4648 11.1314 13.4121 10.8875C13.3594 10.6438 13.2177 10.4285 13.0151 10.2832V10.2825C12.6885 10.0519 12.4218 9.74663 12.2373 9.39185C12.0518 9.03503 11.9546 8.63897 11.9546 8.23682ZM8.96703 8.23682C8.96693 7.40847 8.2954 6.73682 7.46703 6.73682C6.63875 6.73692 5.96713 7.40853 5.96703 8.23682C5.96703 9.06518 6.63869 9.73672 7.46703 9.73682C8.29546 9.73682 8.96703 9.06524 8.96703 8.23682ZM10.467 8.23682C10.467 9.89367 9.12389 11.2368 7.46703 11.2368C5.81026 11.2367 4.46703 9.89361 4.46703 8.23682C4.46713 6.58011 5.81032 5.23692 7.46703 5.23682C9.12382 5.23682 10.4669 6.58005 10.467 8.23682ZM13.4546 8.23682C13.4546 8.39812 13.4937 8.55732 13.5681 8.70044C13.6239 8.80765 13.6984 8.90353 13.7878 8.98389L13.8823 9.05933L13.8882 9.06372C14.3938 9.42595 14.7471 9.96306 14.8784 10.571C15.0097 11.1791 14.9098 11.8144 14.5986 12.353C14.2874 12.8917 13.7869 13.2954 13.1946 13.4854C12.6023 13.6753 11.9606 13.6377 11.3943 13.3806L11.387 13.3777C11.2407 13.3096 11.0801 13.2776 10.9189 13.2847C10.7577 13.2917 10.6003 13.3373 10.4604 13.418C10.3206 13.4987 10.2023 13.6122 10.1155 13.7483C10.0287 13.8844 9.97589 14.0394 9.96166 14.2002V14.2053C9.90265 14.8257 9.61409 15.4017 9.15307 15.821C8.69195 16.2404 8.09105 16.4729 7.46776 16.4729C6.84443 16.4729 6.24361 16.2404 5.78246 15.821C5.32136 15.4017 5.03289 14.8258 4.97387 14.2053L4.97313 14.2002C4.95894 14.0394 4.90614 13.8844 4.81933 13.7483C4.73247 13.6121 4.61426 13.4987 4.47436 13.418C4.33446 13.3373 4.1772 13.2917 4.01586 13.2847C3.85461 13.2777 3.69413 13.3095 3.54784 13.3777L3.54052 13.3806C2.97419 13.6377 2.33249 13.6752 1.74022 13.4854C1.14791 13.2954 0.647362 12.8916 0.336172 12.353C0.0249851 11.8144 -0.074907 11.1791 0.0563865 10.571C0.187705 9.96306 0.540952 9.42594 1.04662 9.06372L1.05248 9.05933C1.18448 8.96667 1.29226 8.84351 1.36669 8.70044C1.4411 8.55732 1.48017 8.39813 1.48021 8.23682C1.48021 8.0755 1.44107 7.91633 1.36669 7.77319C1.29224 7.63001 1.18459 7.50628 1.05248 7.41357L1.04589 7.40918C0.540889 7.04675 0.188827 6.50949 0.0578514 5.90186C-0.0731173 5.29423 0.0260584 4.65961 0.336904 4.12134C0.647755 3.58305 1.14774 3.17928 1.73949 2.98901C2.25714 2.8226 2.81287 2.82993 3.32299 3.00586L3.53905 3.09155L3.54638 3.09521C3.69263 3.16334 3.85321 3.19523 4.01439 3.18823C4.17561 3.18118 4.3331 3.13555 4.47289 3.05493C4.61273 2.97425 4.73103 2.86072 4.81786 2.72461C4.90468 2.58851 4.95745 2.43351 4.97167 2.27271C4.97443 2.24154 4.97921 2.21099 4.98559 2.18115C5.06219 1.59394 5.34296 1.05156 5.78246 0.651855C6.24359 0.232522 6.84448 0 7.46776 0C8.09105 3.21756e-05 8.69195 0.232495 9.15307 0.651855C9.55656 1.01883 9.82773 1.50586 9.9287 2.0376L9.96166 2.26831V2.27271C9.97588 2.43343 10.0287 2.58855 10.1155 2.72461C10.2023 2.86068 10.3207 2.97425 10.4604 3.05493C10.6003 3.1356 10.7577 3.18116 10.9189 3.18823C11.0801 3.19528 11.2407 3.16331 11.387 3.09521L11.3943 3.09229C11.9606 2.83524 12.6023 2.79763 13.1946 2.98755C13.7869 3.17752 14.2874 3.5813 14.5986 4.11987C14.9098 4.65847 15.0097 5.29384 14.8784 5.90186C14.7471 6.50991 14.3939 7.04767 13.8882 7.40991L13.8823 7.41357C13.7502 7.50628 13.6426 7.62999 13.5681 7.77319C13.4937 7.91637 13.4546 8.07546 13.4546 8.23682Z",
                            fill: "#8A8D93",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.$isMobile
                      ? _c("span", { staticClass: "t-clamp t-clamp--line" }, [
                          _vm._v(
                            _vm._s(_vm.workspace.displayName) +
                              " Settings\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "t-nav__action t-mar--l-ti" }, [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$t("nav.actions.new"),
                          expression: "$t('nav.actions.new')",
                        },
                      ],
                      staticClass: "t-pos--rel",
                      attrs: {
                        href: "https://help.trainn.co/uwzNgv9RU8k-feature-enhancements/QUeAkmRcR4g-set-up-video-brand-styles?utm_source=what%27s_new",
                        target: "_blank",
                      },
                    },
                    [
                      _c("RocketIcon", {
                        attrs: { size: "14", fill: "currentColor" },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "t-nav__action t-mar--l-mi" }, [
                  _c(
                    "a",
                    { on: { click: _vm.openLearningCenter } },
                    [
                      _c("HelpIcon", {
                        attrs: { size: "14", fill: "currentColor" },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-nav__create t-pos--rel" },
              [
                _c(
                  "t-button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value:
                          !_vm.$user.eligible("walk_through_videos") &&
                          _vm.$t("recorder.recording_blocked"),
                        expression:
                          "!$user.eligible('walk_through_videos') && $t('recorder.recording_blocked')",
                      },
                    ],
                    staticClass: "t-pad--l-ti t-pad--r-ti",
                    attrs: {
                      variant: "primary",
                      fluid: "",
                      disabled:
                        !_vm.$user.can("create", "video") ||
                        !_vm.$user.eligible("walk_through_videos"),
                      size: "xsmall",
                    },
                    on: {
                      click: function ($event) {
                        _vm.$user.can("create", "video") &&
                          _vm.$user.eligible("walk_through_videos") &&
                          _vm.openCreateModal()
                      },
                    },
                  },
                  [
                    _c("VideoIcon", {
                      staticClass: "t-mar--r-ti",
                      attrs: { size: "15", fill: "currentColor" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Create Video")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-nav__section" }, [
      _vm._v("\n        Create "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-nav__section" }, [
      _vm._v("\n        Distribute "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-nav__section" }, [
      _vm._v("\n        Manage "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }